// CONSTANTS are all caps.
const NS = "TextFeature";
const CLS = "textFeature";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/textFeature.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class TextFeature {

	constructor($el) {
		// $el is the widget node return by the loadTextFeature function
		this.$el = $el;
	}

	init() {
		this.setTextFeature();
	}

	setTextFeature() {
		let wg = $(this.$el);
		let text = wg.text().trim();
		let firstLetter = text[0];
		text = text.substring(1);
		wg.text(text);
		wg.html(`
		    <p><span class="${CLS}-bigText">${firstLetter}</span>${text}</p>
		`);
		// wg.html(`
		//     <div class="${CLS}-bigText">${firstLetter}</div>
		//     <p><span class="${CLS}-bigText">${firstLetter}</span>${text}</p>
		// `);
	}

	//Add more functions like on above here

}
